/* unplugin-vue-components disabled */import { render } from "./AnswerCard.vue?vue&type=template&id=45adfaa9&scoped=true"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"

import "./AnswerCard.vue?vue&type=style&index=0&id=45adfaa9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45adfaa9"]])

export default __exports__